import React from "react";
import Navbar from "../Collections/HomePage/Navbar/Navbar";
import WorkHero from "../Collections/WorkPage-TsundokuAdminStudio/WorkHero/WorkHero";
import WorksHeader from "../Collections/WorkPage-TsundokuAdminStudio/WorksHeader/WorksHeader";
import WorksBody from "../Collections/WorkPage-TsundokuAdminStudio/WorksBody/WorksBody";
import WorksCarousel from "../Collections/WorkPage-TsundokuAdminStudio/WorksCarousel/WorksCarousel";
import Footer from "../Collections/HomePage/Footer/Footer";

const WorkGroup = () => {
  return (
    <>
      <Navbar />
      <WorkHero />
      <WorksHeader />
      <WorksBody />
      <WorksCarousel />
      <Footer />
    </>
  );
};

export default WorkGroup;
